import { gql } from '@apollo/client';

const fields = gql`
    fragment ProfileConflictActivityFields on profile_conflict_activity {
        id
        conflictId
        reviewId
        conversationId
        kind
        section
        personId1
        personId2
        personName1
        personName2
        status
        outcome
        actorName
        createdAt
    }
`;

// History requests IDs first so expensive person/review lookups run only for the selected page.
// Other queues request all display rows for DataPanel sorting, filtering and pagination.
export const ProfileConflictActivity = gql`
    query ProfileConflictActivity(
        $where: profile_conflict_activity_bool_exp!
        $limit: Int
        $offset: Int!
        $includeDetails: Boolean!
    ) {
        records: profile_conflict_activity(
            where: $where
            limit: $limit
            offset: $offset
            order_by: [{ createdAt: desc }, { id: asc }]
        ) {
            id
            ...ProfileConflictActivityFields @include(if: $includeDetails)
        }
        total: profile_conflict_activity_aggregate(where: $where) {
            aggregate {
                count
            }
        }
    }
    ${fields}
`;

/** Enriches the history IDs selected by ProfileConflictActivity without paginating again. */
export const ProfileConflictHistoryRecords = gql`
    query ProfileConflictHistoryRecords($ids: [String!]!, $limit: Int!) {
        records: profile_conflict_activity(
            where: { id: { _in: $ids } }
            limit: $limit
            offset: 0
            order_by: [{ createdAt: desc }, { id: asc }]
        ) {
            ...ProfileConflictActivityFields
        }
    }
    ${fields}
`;

export const ProfileConflictActivityUsers = gql`
    query ProfileConflictActivityUsers($systemUserId: String!) {
        users: profile_conflict_activity(
            where: { section: { _eq: "history" }, actorId: { _neq: $systemUserId } }
            distinct_on: actorId
            order_by: { actorId: asc }
        ) {
            actorId
            actorName
        }
    }
`;

export const ProfileConflictActivityDetails = gql`
    query ProfileConflictActivityDetails($where: profile_conflict_activity_bool_exp!) {
        records: profile_conflict_activity(where: $where, limit: 1, order_by: [{ createdAt: desc }, { id: asc }]) {
            ...ProfileConflictActivityFields
            reason
            error
            contactValue
            profileUrl
            filePath
            fileName
            review {
                history(order_by: [{ createdAt: asc }, { id: asc }]) {
                    id
                    kind
                    personId1
                    personId2
                    contactValue
                    profileUrl
                    filePath
                    fileName
                }
                merges(order_by: [{ createdAt: asc }, { id: asc }]) {
                    id
                    personId1: oldPersonId
                    personId2: newPersonId
                }
            }
        }
    }
    ${fields}
`;

// Acknowledge finished investigations without closing any unresolved conflict; Hasura sets reviewedBy.
export const MarkProfileConflictReviewed = gql`
    mutation MarkProfileConflictReviewed($id: String!, $reviewedAt: bigint!) {
        update_profile_conflict_reviews(where: { id: { _eq: $id } }, _set: { reviewedAt: $reviewedAt }) {
            affected_rows
        }
    }
`;
